import { Button, Col, Input, Row } from "antd";
import { Settings } from "@version2/domain-package";

type EncryptedFieldProps = {
	settings: Settings;
	onSettingsChange: (settings: Settings) => void;
};

const EncryptedField = ({
	settings,
	onSettingsChange,
}: EncryptedFieldProps) => {
	const hasStoredValue =
		settings._.originalValue !== undefined &&
		settings._.originalValue !== null &&
		settings._.originalValue !== "";

	return (
		<Row>
			<Col flex="auto">
				<Input value={"••••••••••••••••"} disabled={true} />
			</Col>
			<div style={{ width: 12 }} />
			<Col>
				<Button
					type="text"
					onClick={() =>
						onSettingsChange(
							settings.copyWith({ editedValue: "" })
						)
					}
				>
					{hasStoredValue ? "Change" : "Set"}
				</Button>
			</Col>
		</Row>
	);
};

export default EncryptedField;
